var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBloodPressureWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "drop-2",
    transform: "translate(5.000000, 6.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49976227,1 L11.4664411,6.60273443 C11.8344966,7.23273557 12.01887,7.95464579 11.9984737,8.68550292 C11.9745051,9.38905458 11.7782627,10.075642 11.4272618,10.6841473 C10.6132532,12.1126302 9.10842035,13 7.49987752,13 C5.89444595,13 4.39122643,12.1144893 3.57687208,10.6892598 C3.22379698,10.0784306 3.02617174,9.38905458 3.00162701,8.68259809 C2.9828824,8.02912584 3.12638636,7.38263093 3.41749024,6.80138036 L3.53354432,6.58658352 L7.49976227,1 Z M10.3482389,8 C9.98828728,8 9.69647745,8.291821 9.69647745,8.65177103 C9.69514078,9.78034802 8.78026802,10.6952241 7.65132415,10.6964582 C7.29180981,10.6964579 7,10.9882789 7,11.348229 C7,11.708179 7.29180981,12 7.65176141,12 C9.50021972,11.9980455 10.9979062,10.5003447 11,8.65222422 C11,8.291821 10.7081905,8 10.3482389,8 Z M10.6496197,0 L14.4857199,4.85717137 C15.0738944,5.77573845 15.1606584,6.8376953 14.7300109,7.84865527 C14.3241926,8.78916721 13.5415234,9.55711275 12.5378748,10 C12.7165066,9.53018042 12.8158231,9.03866537 12.8323759,8.54203814 C12.8602397,7.6586327 12.6107069,6.78619966 12.1124691,6.02573535 C12.108055,6.01900225 12.1033651,6.01239387 12.0983993,6.00603483 L12.0983993,6.00603483 L9,2.08301641 L10.6496197,0 Z M4.35038033,0 L6,2.08301641 L2.90160075,6.00603483 C2.89663489,6.01239387 2.89194496,6.01900225 2.88753089,6.02573535 C2.38929306,6.78619966 2.13976033,7.6586327 2.16762411,8.54203814 C2.18417687,9.03866537 2.28349338,9.53018042 2.46212517,10 C1.45847664,9.55711275 0.675807377,8.78916721 0.269989059,7.84865527 C-0.160658351,6.8376953 -0.073894352,5.77573845 0.514280098,4.85717137 L4.35038033,0 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBloodPressureWhite);
export default __webpack_public_path__ + "static/media/icon-blood-pressure-white.339ae95cc01e95c1a8bffda4c1b8ce76.svg";
export { ForwardRef as ReactComponent };